export default __webpack_public_path__ + "images/c006b5d741e91d45b634b854f7dac1e7-accessDenied--light.png";